import { useEffect } from "react"

import { cancelRequestOnUnload } from "../api/connect"

export function useCancelOnClose(id, active) {
  useEffect(() => {
    if (!id || !active) {
      return
    }

    const confirmClose = (event) => {
      event.preventDefault()
      event.returnValue = ""
      return ""
    }

    const cancelOnLeave = (event) => {
      if (event.persisted) {
        return
      }
      cancelRequestOnUnload(id)
    }

    window.addEventListener("beforeunload", confirmClose)
    window.addEventListener("pagehide", cancelOnLeave)

    return () => {
      window.removeEventListener("beforeunload", confirmClose)
      window.removeEventListener("pagehide", cancelOnLeave)
    }
  }, [id, active])
}
